{
    "name": "@crczp/platform",
    "version": "3.8.0",
    "license": "MIT",
    "private": true,
    "dependencies": {
        "@acrodata/code-editor": "^0.5.0",
        "@angular/animations": "~20.3.0",
        "@angular/cdk": "~20.2.0",
        "@angular/common": "~20.3.16",
        "@angular/compiler": "~20.3.16",
        "@angular/core": "~20.3.16",
        "@angular/forms": "~20.3.0",
        "@angular/material": "~20.2.0",
        "@angular/platform-browser": "~20.3.0",
        "@angular/platform-browser-dynamic": "~20.3.0",
        "@angular/router": "~20.3.0",
        "@codemirror/search": "^6.5.0",
        "@danielmoncada/angular-datetime-picker": "^20.0.0",
        "@dushixiang/guacamole-common-js": "^1.6.0-fix",
        "@json2csv/plainjs": "^7.0.6",
        "@ngneat/cashew": "^5.1.0",
        "@nx/devkit": "^21.6.0",
        "@sentinel/auth": "20.0.3",
        "@sentinel/common": "20.1.6",
        "@sentinel/components": "20.1.13",
        "@sentinel/layout": "20.1.3",
        "@sqlite.org/sqlite-wasm": "3.53.0-build1",
        "angular-mgl-timeline": "^1.1.0",
        "comlink": "^4.4.2",
        "date-fns": "^4.1.0",
        "dom-to-svg": "^0.12.0",
        "drizzle-orm": "^0.45.2",
        "echarts": "^6.0.0",
        "fast-levenshtein": "^3.0.0",
        "file-saver": "^2.0.0",
        "ngx-echarts": "^20.0.1",
        "ngx-file-drag-drop": "^11.0.0",
        "rxjs": "^7.8.0",
        "uuid": "^13.0.0",
        "vis-data": "^8.0.0",
        "vis-network": "^10.0.0",
        "zod-validation-error": "^4.0.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@analogjs/platform": "^1.21.0",
        "@analogjs/vite-plugin-angular": "^1.21.0",
        "@analogjs/vitest-angular": "^1.21.0",
        "@angular-devkit/build-angular": "~20.3.0",
        "@angular-devkit/core": "~20.3.0",
        "@angular-devkit/schematics": "~20.3.0",
        "@angular-eslint/eslint-plugin-template": "~20.4.0",
        "@angular-eslint/template-parser": "~20.4.0",
        "@angular/build": "~20.3.0",
        "@angular/cli": "~20.0.0",
        "@angular/compiler-cli": "~20.3.0",
        "@angular/language-service": "~20.3.0",
        "@eslint/js": "^9.39.2",
        "@nx/angular": "^21.6.0",
        "@nx/devkit": "^21.6.0",
        "@nx/esbuild": "^21.6.0",
        "@nx/eslint": "^21.6.0",
        "@nx/eslint-plugin": "^21.6.0",
        "@nx/js": "21.6.10",
        "@nx/playwright": "^21.6.0",
        "@nx/plugin": "^21.6.0",
        "@nx/vite": "21.6.10",
        "@nx/web": "21.6.10",
        "@nx/workspace": "^21.6.0",
        "@playwright/test": "^1.56.0",
        "@rdlabo/eslint-plugin-rules": "^21.0.0",
        "@schematics/angular": "~20.3.0",
        "@swc-node/register": "~1.11.0",
        "@swc/cli": "~0.7.0",
        "@swc/core": "~1.13.0",
        "@swc/helpers": "~0.5.11",
        "@types/echarts": "^5.0.0",
        "@types/file-saver": "^2.0.0",
        "@types/node": "^24.7.0",
        "@typescript-eslint/utils": "^8.54.0",
        "@vitest/coverage-v8": "^3.2.0",
        "@vitest/ui": "^3.2.0",
        "@vitest/web-worker": "3.2.4",
        "angular-eslint": "~20.4.0",
        "angular-file": "^4.0.0",
        "angular-oauth2-oidc": "^20.0.0",
        "angular-oauth2-oidc-jwks": "^20.0.0",
        "autoprefixer": "^10.4.0",
        "caret-pos": "^2.0.0",
        "drizzle-kit": "^0.31.10",
        "esbuild": "^0.27.2",
        "eslint": "^9.39.2",
        "eslint-config-prettier": "^10.1.0",
        "eslint-plugin-playwright": "^1.8.0",
        "jiti": "^2.6.0",
        "jsdom": "~22.1.0",
        "jsonc-eslint-parser": "^2.4.0",
        "marked": "^15.0.12",
        "ng-packagr": "~20.3.0",
        "nx": "^21.6.0",
        "postcss": "^8.5.0",
        "postcss-url": "~10.1.3",
        "prettier": "^3.6.0",
        "ts-node": "^10.9.0",
        "tslib": "^2.3.0",
        "typescript": "~5.9.0",
        "typescript-eslint": "^8.54.0",
        "verdaccio": "^6.2.0",
        "vite": "^7.1.0",
        "vite-tsconfig-paths": "^5.1.0",
        "vitest": "^3.2.0",
        "zod": "^3.25.0",
        "zod-class": "^0.0.18"
    },
    "overrides": {
        "@sentinel/common": "20.1.6",
        "ngx-indexed-db": {
            "@angular/common": "^20.0.0",
            "@angular/core": "^20.0.0",
            "rxjs": "^7.8.0"
        },
        "ngx-file-drag-drop": {
            "@angular/cdk": "^20.0.0",
            "@angular/common": "^20.0.0",
            "@angular/core": "^20.0.0",
            "@angular/material": "^20.0.0",
            "rxjs": "^7.8.0"
        }
    },
    "nx": {
        "includedScripts": []
    },
    "workspaces": [
        "./apps/*",
        "./dist/libs/*"
    ]
}
